import { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import ErrorBoundary from 'core/common/components/ErrorBoundary';
import { Config, ConfigProvider, Services, ServicesProvider } from 'core/common/contexts';
import { ObservabilityProvider } from 'core/common/observability/context';
import { FeatureFlagsProvider } from 'core/feature-flags/context';
import { FeatureFlags } from 'core/feature-flags/services';
import i18n from 'core/i18n';
import { ThemeProvider } from 'core/theme/contexts';
import { ThemeConfig } from 'core/theme/entities';

type ProvidersProps = {
  children: ReactNode;
  store: Store;
  services: Services;
  featureFlags: FeatureFlags;
  config: Config;
  themeConfig?: ThemeConfig | null;
};

export const Providers = ({
  children,
  store,
  featureFlags,
  services,
  config,
  themeConfig = null,
}: ProvidersProps) => {
  return (
    <ErrorBoundary fallback={<div />}>
      <I18nextProvider i18n={i18n}>
        <ConfigProvider config={config}>
          <Provider store={store}>
            <ServicesProvider value={services}>
              <ObservabilityProvider>
                <FeatureFlagsProvider featureFlags={featureFlags}>
                  <ThemeProvider themeConfig={themeConfig}>{children}</ThemeProvider>
                </FeatureFlagsProvider>
              </ObservabilityProvider>
            </ServicesProvider>
          </Provider>
        </ConfigProvider>
      </I18nextProvider>
    </ErrorBoundary>
  );
};
